// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Warning-space1-CtWZK {
	margin-bottom: 6px !important;
}

.Warning-space2-i5coB {
	margin-bottom: 12px !important;
}

.Warning-space3-fm5wI {
	margin-bottom: 18px !important;
}

.Warning-space4-xukGb {
	margin-bottom: 24px !important;
}

.Warning-space5-yp4nv {
	margin-bottom: 30px !important;
}

.Warning-space6-Sk4cE {
	margin-bottom: 36px !important;
}

.Warning-space7-lGnQd {
	margin-bottom: 42px !important;
}

.Warning-spaceTop8-hMOfM {
	margin-bottom: 48px !important;
}

.Warning-spaceTop1-LBw2w {
	margin-top: 6px !important;
}

.Warning-spaceTop2-jrey4 {
	margin-top: 12px !important;
}

.Warning-spaceTop3-vMRFW {
	margin-top: 18px !important;
}

.Warning-spaceTop4-LDQKV {
	margin-top: 24px !important;
}

.Warning-spaceTop5-S2_4w {
	margin-top: 30px !important;
}

.Warning-spaceTop6-yMvuv {
	margin-top: 36px !important;
}

.Warning-spaceTop7-wpxqr {
	margin-top: 42px !important;
}

.Warning-spaceTop8-hMOfM {
	margin-top: 48px !important;
}

.Warning-noMargin-d2Xb6 {
	margin: 0px !important;
}

.Warning-padding1-lFywX {
	padding-bottom: 6px !important;
}

.Warning-padding2-pCB8w {
	padding-bottom: 12px !important;
}

.Warning-padding3-SCslu {
	padding-bottom: 18px !important;
}

.Warning-padding4-eBYiN {
	padding-bottom: 24px !important;
}

.Warning-padding5-dD1Xc {
	padding-bottom: 30px !important;
}

.Warning-padding6-N0Wf0 {
	padding-bottom: 36px !important;
}

.Warning-padding7-EhRwZ {
	padding-bottom: 42px !important;
}

.Warning-paddingTop1-bEwyy {
	padding-top: 6px !important;
}

.Warning-paddingTop2-Y76E6 {
	padding-top: 12px !important;
}

.Warning-paddingTop3-srjAD {
	padding-top: 18px !important;
}

.Warning-paddingTop4-GGEPv {
	padding-top: 24px !important;
}

.Warning-paddingTop5-EL4eG {
	padding-top: 30px !important;
}

.Warning-paddingTop6-bLCYI {
	padding-top: 36px !important;
}

.Warning-paddingTop7-GSnLX {
	padding-top: 42px !important;
}

.Warning-noPadding-wqJdf {
	padding: 0px !important;
}

.Warning-textBold-ob53C {
	font-weight: 500 !important;
}

.Warning-textBolder-HgA3k {
	font-weight: 700 !important;
}

.Warning-textNormal-oeQZj {
	font-weight: normal !important;
}

.Warning-spaceBottom20-SKgDt {
	margin-bottom: 20px;
}

.Warning-spaceBottom10-wnt5T {
	margin-bottom: 10px;
}

.Warning-marginNone-YHLZs {
	margin: 0;
}

.Warning-spaceBottom15-S0y8Q {
	margin-bottom: 15px;
}

.Warning-marginTopNone-vIoZR {
	margin-top: 0;
}

.Warning-spaceTop11-Yd2VN {
	margin-top: 11px;
}

.Warning-spaceTop21-qBHsi {
	margin-top: 21px;
}

.Warning-spaceTop20-CKGI3 {
	margin-top: 20px;
}

.Warning-spaceTop10-CtENk {
	margin-top: 10px;
}

/*New Design Text Colors */

.Warning-textDarkBlue-Damiq {
	color: rgb(20, 39, 94) !important;
}

.Warning-textLightBlue-oA315 {
	color: rgb(57, 87, 106) !important;
}

.Warning-textLightSandleGreen-GFfef {
	color: rgb(76, 86, 41) !important;
}

.Warning-textLightBrown-vQUl0 {
	color: rgb(115, 79, 33) !important;
}

.Warning-textMediumMaroon-G4MIl {
	color: rgb(87, 37, 51) !important;
}

.Warning-textBrown-ev2KN {
	color: rgb(160, 47, 24) !important;
}

.Warning-textMaroon-SD9CV {
	color: rgb(155, 49, 67) !important;
}

.Warning-textDarkBrown-pGa1p {
	color: rgb(83, 18, 16) !important;
}

.Warning-textMediumBrown-ELXYy {
	color: rgb(142, 28, 10) !important;
}

.Warning-textSkyBlue-BDI_2 {
	color: rgb(37, 117, 141) !important;
}

.Warning-textGray-ToNGL {
	color: rgb(77, 65, 51) !important;
}

.Warning-root-jUkDk {
	padding-left: 20px;
	padding-right: 20px;
}

.Warning-container-XhvbE {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: var(--max-content-width);
}

.Warning-textJumbo-bAGv7 {
	font-size: 95px;
	font-weight: bold;
	margin: 0;
}

.Warning-textMedium-iSX7X {
	font-size: 85px;
	font-weight: bold;
	margin: 0;
}

.Warning-textCenter-kB1x8 {
	text-align: center;
}

.Warning-listStyled-tcCdV {
	padding-left: 0;
	list-style: none;
}

.Warning-subTitle-lhDBt {
	font-size: 15px;
	color: var(--primary-foreground);
}

a,
a:hover {
	color: var(--primary-link-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/warning/Warning.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mCAAmC;AACpC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;;CAEC,qCAAqC;AACtC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: var(--max-content-width);\n}\n\n.textJumbo {\n\tfont-size: 95px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 85px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.listStyled {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.subTitle {\n\tfont-size: 15px;\n\tcolor: var(--primary-foreground);\n}\n\na,\na:hover {\n\tcolor: var(--primary-link-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Warning-space1-CtWZK`,
	"space2": `Warning-space2-i5coB`,
	"space3": `Warning-space3-fm5wI`,
	"space4": `Warning-space4-xukGb`,
	"space5": `Warning-space5-yp4nv`,
	"space6": `Warning-space6-Sk4cE`,
	"space7": `Warning-space7-lGnQd`,
	"spaceTop8": `Warning-spaceTop8-hMOfM`,
	"spaceTop1": `Warning-spaceTop1-LBw2w`,
	"spaceTop2": `Warning-spaceTop2-jrey4`,
	"spaceTop3": `Warning-spaceTop3-vMRFW`,
	"spaceTop4": `Warning-spaceTop4-LDQKV`,
	"spaceTop5": `Warning-spaceTop5-S2_4w`,
	"spaceTop6": `Warning-spaceTop6-yMvuv`,
	"spaceTop7": `Warning-spaceTop7-wpxqr`,
	"noMargin": `Warning-noMargin-d2Xb6`,
	"padding1": `Warning-padding1-lFywX`,
	"padding2": `Warning-padding2-pCB8w`,
	"padding3": `Warning-padding3-SCslu`,
	"padding4": `Warning-padding4-eBYiN`,
	"padding5": `Warning-padding5-dD1Xc`,
	"padding6": `Warning-padding6-N0Wf0`,
	"padding7": `Warning-padding7-EhRwZ`,
	"paddingTop1": `Warning-paddingTop1-bEwyy`,
	"paddingTop2": `Warning-paddingTop2-Y76E6`,
	"paddingTop3": `Warning-paddingTop3-srjAD`,
	"paddingTop4": `Warning-paddingTop4-GGEPv`,
	"paddingTop5": `Warning-paddingTop5-EL4eG`,
	"paddingTop6": `Warning-paddingTop6-bLCYI`,
	"paddingTop7": `Warning-paddingTop7-GSnLX`,
	"noPadding": `Warning-noPadding-wqJdf`,
	"textBold": `Warning-textBold-ob53C`,
	"textBolder": `Warning-textBolder-HgA3k`,
	"textNormal": `Warning-textNormal-oeQZj`,
	"spaceBottom20": `Warning-spaceBottom20-SKgDt`,
	"spaceBottom10": `Warning-spaceBottom10-wnt5T`,
	"marginNone": `Warning-marginNone-YHLZs`,
	"spaceBottom15": `Warning-spaceBottom15-S0y8Q`,
	"marginTopNone": `Warning-marginTopNone-vIoZR`,
	"spaceTop11": `Warning-spaceTop11-Yd2VN`,
	"spaceTop21": `Warning-spaceTop21-qBHsi`,
	"spaceTop20": `Warning-spaceTop20-CKGI3`,
	"spaceTop10": `Warning-spaceTop10-CtENk`,
	"textDarkBlue": `Warning-textDarkBlue-Damiq`,
	"textLightBlue": `Warning-textLightBlue-oA315`,
	"textLightSandleGreen": `Warning-textLightSandleGreen-GFfef`,
	"textLightBrown": `Warning-textLightBrown-vQUl0`,
	"textMediumMaroon": `Warning-textMediumMaroon-G4MIl`,
	"textBrown": `Warning-textBrown-ev2KN`,
	"textMaroon": `Warning-textMaroon-SD9CV`,
	"textDarkBrown": `Warning-textDarkBrown-pGa1p`,
	"textMediumBrown": `Warning-textMediumBrown-ELXYy`,
	"textSkyBlue": `Warning-textSkyBlue-BDI_2`,
	"textGray": `Warning-textGray-ToNGL`,
	"root": `Warning-root-jUkDk`,
	"container": `Warning-container-XhvbE`,
	"textJumbo": `Warning-textJumbo-bAGv7`,
	"textMedium": `Warning-textMedium-iSX7X`,
	"textCenter": `Warning-textCenter-kB1x8`,
	"listStyled": `Warning-listStyled-tcCdV`,
	"subTitle": `Warning-subTitle-lhDBt`
};
module.exports = ___CSS_LOADER_EXPORT___;
